import { fetchProvider } from './fetch';
import { InfoForExample, MostSubscribedProducts, ProductInfo } from '../model/product';
import { SiteConfigurationResponse, SiteInfo } from '../model/site';
import { LastEligibleOrderInfo } from '../model/order';
import { SubscriptionInfo } from '../model/subscriptionProducts';

export const CentralHubService = () => {
  const fetch = fetchProvider('autoshipment-central-hub-front', '/public/api/autoshipment/');
  const fetchSemiProtected = fetchProvider('autoshipment-central-hub-front', '/semiprotected/api/autoshipment/');

  const getMostSubscribedProducts = async (siteDomain: string, language: string) =>
    (
      await fetch.get<MostSubscribedProducts>(
        `central-hub/most-subscribed?siteDomain=${siteDomain}&language=${language}`,
      )
    ).responseBody;

  const getInfoForExamplesSection = async (siteDomain: string, language: string) =>
    (
      await fetch.get<InfoForExample[]>(
        `central-hub/site-example-article-savings?siteDomain=${siteDomain}&language=${language}`,
      )
    ).responseBody;

  const getSiteInfo = async (siteDomain: string) =>
    (await fetch.get<SiteInfo>(`central-hub/site-info?siteDomain=${siteDomain}`)).responseBody;

    const getLastEligibleOrder = async (siteDomain: string): Promise<LastEligibleOrderInfo | undefined> => {
        const response = await fetchSemiProtected.post<LastEligibleOrderInfo>(`order/last-eligible-order`, {
            siteDomain: siteDomain,
        });
        if (response.statusCode === 204) return undefined;
        return response.responseBody;
    };
  const getPdpArticleInformation = async (shopIdentifier: string, language: string) =>
    (
      await fetch.get<ProductInfo>(
        `central-hub/pdp-article?shopIdentifier=${shopIdentifier}&language=${language}`,
      )
    ).responseBody;

  const getSiteConfig = async (siteDomain: string) =>
    (await fetch.get<SiteConfigurationResponse>(`site/${siteDomain}`)).responseBody;

  const getSubscriptions = async (siteDomain: string) =>
    (
      await fetchSemiProtected.get<SubscriptionInfo>(
        `central-hub/upcoming-autoshipments?siteDomain=${siteDomain}`,
      )
    ).responseBody;

  return {
    getMostSubscribedProducts,
    getInfoForExamplesSection,
    getSiteInfo,
    getSiteConfig,
    getLastEligibleOrder,
    getPdpArticleInformation,
    getSubscriptions,
  };
};
